const HeartDiamond = ({ ...props }) => {
  return (
    <svg
      version="1.1"
      id="Layer_1"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      x="0px"
      y="0px"
      viewBox="0 0 100 100"
      xmlSpace="preserve"
      fill="currentColor"
      {...props}
    >
      <path
        d="M96.1,34.4c0-16.97-8.76-24.16-13.98-26.93c-7.58-4.04-16.93-3.93-24.41,0.25c-0.01,0-0.02,0.01-0.02,0.01
	c-3.12,1.75-5.75,4.19-7.69,7.07c-1.94-2.88-4.58-5.32-7.69-7.07c-0.01,0-0.02-0.01-0.02-0.01c-7.47-4.19-16.82-4.29-24.4-0.25
	C12.66,10.24,3.9,17.43,3.9,34.4c0,3.96,0.59,7.97,1.74,11.92c0,0,0,0,0,0c0,0,0,0,0,0s0,0,0,0c2.8,9.57,9.1,19.22,18.73,28.69
	c7.64,7.52,15.76,13.43,21.69,17.74c1.33,0.97,2.54,1.84,3.58,2.63c0.04,0.03,0.08,0.05,0.12,0.06c0.02,0.01,0.03,0.02,0.05,0.02
	c0.06,0.02,0.13,0.03,0.19,0.03s0.13-0.01,0.19-0.03c0.02-0.01,0.03-0.02,0.05-0.02c0.04-0.02,0.08-0.04,0.12-0.06
	c1.04-0.78,2.25-1.66,3.58-2.63c5.93-4.31,14.05-10.21,21.69-17.74c9.62-9.47,15.92-19.12,18.73-28.69c0,0,0,0,0,0s0,0,0,0
	c0,0,0,0,0,0C95.51,42.37,96.1,38.36,96.1,34.4z M94.9,34.4c0,3.44-0.48,6.91-1.38,10.35L81.11,27.22l1.26-18.23
	C90.45,13.71,94.9,22.68,94.9,34.4z M50.98,65.96l7.42-4.95v11.54L50.98,65.96z M50,93.37l-8.28-19.32L50,66.7l8.28,7.36L50,93.37z
	 M33.06,17.29l14.82,6.35l-15.25,2.54L33.06,17.29z M50,24.5l17.47,2.91l1.91,13.36l-10.83,18.7L50,65.17l-8.55-5.7l-10.83-18.7
	l1.91-13.36L50,24.5z M70.39,39.41l-1.7-11.89l10.61,0.42L70.39,39.41z M80.48,28.4l12.37,17.47l-17.03,6.75l-5.12-11.64L80.48,28.4
	z M79.94,26.77l-11.37-0.45l-0.46-9.59l13.05-7.65L79.94,26.77z M66.94,17.29l0.42,8.89l-15.25-2.54L66.94,17.29z M29.61,39.41
	l-8.92-11.46l10.61-0.42L29.61,39.41z M31.43,26.32l-11.37,0.45L18.84,9.08l13.05,7.65L31.43,26.32z M29.31,40.98l-5.12,11.64
	L7.15,45.87L19.52,28.4L29.31,40.98z M23.91,53.81l0.27,19.3c-8.49-8.59-14.21-17.31-17-25.94L23.91,53.81z M25.11,54.28L40.4,60.3
	v13.02l-15.02,0.64L25.11,54.28z M25.3,53.07l4.77-10.85l9.55,16.49L25.3,53.07z M41.6,61.02l7.42,4.95l-7.42,6.6V61.02z
	 M69.93,42.22l4.77,10.85l-14.32,5.64L69.93,42.22z M59.6,60.3l15.29-6.02l-0.27,19.68L59.6,73.32V60.3z M76.09,53.81l16.74-6.64
	c-2.79,8.63-8.51,17.35-17,25.94L76.09,53.81z M80.58,8.04l-13.01,7.62l-8.51-7.3C65.72,4.94,73.79,4.82,80.58,8.04z M49.49,16.21
	c0,0.01,0.01,0.01,0.01,0.02c0.02,0.03,0.05,0.06,0.08,0.09c0.03,0.03,0.05,0.06,0.09,0.08c0.01,0,0.01,0.01,0.02,0.01
	c0.02,0.02,0.05,0.02,0.08,0.03c0.04,0.02,0.08,0.04,0.12,0.04c0.04,0.01,0.07,0,0.11,0c0.04,0,0.08,0,0.12-0.01
	c0.04-0.01,0.08-0.03,0.12-0.04c0.03-0.01,0.05-0.01,0.08-0.03c0.01,0,0.01-0.01,0.02-0.01c0.03-0.02,0.06-0.05,0.09-0.08
	c0.03-0.03,0.06-0.05,0.08-0.09c0-0.01,0.01-0.01,0.02-0.02c1.8-2.94,4.36-5.43,7.42-7.23l8.45,7.24L50,23.24l-16.38-7.02l8.45-7.24
	C45.13,10.78,47.69,13.27,49.49,16.21z M40.95,8.36l-8.51,7.3L19.42,8.04C22.7,6.49,26.27,5.7,29.85,5.7
	C33.68,5.7,37.5,6.59,40.95,8.36z M17.63,8.99l1.26,18.23L6.48,44.74C5.58,41.31,5.1,37.83,5.1,34.4
	C5.1,22.68,9.55,13.71,17.63,8.99z M46.77,91.78c-5.64-4.1-13.26-9.66-20.54-16.65l14.38-0.61l7.96,18.58
	C48,92.68,47.4,92.24,46.77,91.78z M53.23,91.78c-0.63,0.46-1.24,0.9-1.81,1.32l7.96-18.58l14.38,0.61
	C66.49,82.12,58.87,87.68,53.23,91.78z"
      />
    </svg>
  )
}

export default HeartDiamond
